import "core-js/modules/es.object.assign";
import "core-js/modules/es.string.trim";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/

/* eslint-disable camelcase */
import { rootContext } from 'wfui-digital-core/es/lib';
import { getStore } from '../store/store';
import logger from '../logger/logger';
import sendBusinessEvent from '../business-events/business-events';
import { requestVoiceVerificationNavigation } from '../store/navigation/actions';
import { loadChatbot } from '../store/chatbot/actions';
import { loadNuance, loadAuxiWebsdk } from '../store/nuance/actions';
import modalNavigation from './navigation-types/modal-navigation';
import locationNavigation from './navigation-types/location-navigation';
import browserNavigation from './navigation-types/browser-navigation';
import samlNavigation from './navigation-types/saml-navigation';
import featureNavigation from './navigation-types/feature-navigation';
import foreseeNavigation from './navigation-types/foresee-navigation';
import biometricNavigation from './navigation-types/biometric-navigation';
import pdfNavigation from './navigation-types/pdf-navigation';

var routeNavigation = function routeNavigation(navigation) {
  var _ref = navigation || {},
      navigationItem = _ref.navigationItem;

  var displayType = navigationItem.displayType.trim();
  var dataAttributes = navigationItem.anchorTagAttributes || {};
  var anchorTagAttr = dataAttributes['data-bev-name'];
  navigationItem.url = (navigationItem.useContext ? rootContext() + '/' : '') + navigationItem.navigationUrl; // special case for foresee navigation

  if ('FOOTER_FEEDBACK' === navigationItem.linkId || 'foresee' === displayType || 'foresee' === dataAttributes['data-custom-display']) {
    return foreseeNavigation(navigation);
  } // special case for nuance navigation


  if ('chat' === dataAttributes['data-custom-display']) {
    if (typeof window.Inq !== 'undefined') {
      logger.debug('Launching nuance...');
      sendBusinessEvent(dataAttributes['data-bev-name']);
      window.Inq.fireCustomEvent('nuanceMenuItemClicked');
    } else {
      logger.debug('Loading nuance...');
      window.utag_data.enable_nuance = 'true';
      window.WF_NUANCE.nuanceMenuItemClicked = 'true';

      if (typeof window.WF_NUANCE.NOD === 'function') {
        sendBusinessEvent(dataAttributes['data-bev-name']);
        window.WF_NUANCE.NOD();
      }
    }

    return false;
  } // special case for Voice Verification navigation


  if ('VOICE_VERIFICATION' === navigationItem.linkId) {
    logger.debug('Voice verification requested');
    var url = navigationItem.url;
    getStore().dispatch(requestVoiceVerificationNavigation({
      url: url
    }));
    return false;
  } // Special case for Biometric sign on


  if ('BIOMETRIC_SIGN_ON' === navigationItem.linkId || 'biometric-sign-on' === dataAttributes['data-target-view']) {
    logger.info('Biometric signon requested');
    biometricNavigation({
      navigationItem: navigationItem,
      store: getStore()
    });
    return false;
  }

  if ('wfBotAssistant' === (navigationItem.anchorTagAttributes || {})['data-custom-display']) {
    getStore().dispatch(loadChatbot());
    sendBusinessEvent(navigationItem.anchorTagAttributes['data-bev-name']);
    return false;
  }

  if (navigationItem.anchorTagAttributes && navigationItem.anchorTagAttributes['data-custom-display'] === 'AuxiWebSDK') {
    getStore().dispatch(loadAuxiWebsdk());
    sendBusinessEvent(anchorTagAttr);
    return false;
  }

  if (navigationItem.anchorTagAttributes && navigationItem.anchorTagAttributes['data-custom-display'] === 'nuanceWebSDK') {
    getStore().dispatch(loadNuance());
    sendBusinessEvent(anchorTagAttr);
    return false;
  }

  logger.debug('Routing navigation:', displayType);

  switch (displayType) {
    case 'modal':
      return modalNavigation(navigation);

    case 'location':
      return locationNavigation(navigation);

    case 'browser':
      return browserNavigation(navigation);

    case 'saml':
      return samlNavigation(navigation);

    case 'pdf':
      return pdfNavigation(navigation);

    case 'ignore':
      if ('camera' === navigationItem.deviceFeature) {
        return samlNavigation(Object.assign({}, navigation, {
          displayType: 'saml'
        }));
      } else {
        logger.error('Could not determine navigation', displayType, navigationItem.deviceFeature);
        return false;
      }

    case 'signOff':
    default:
      logger.error('Could not determine the display type of navigation', displayType);
      return false;
  }
};

export default routeNavigation;